import { render, staticRenderFns } from "./InterfaceView.vue?vue&type=template&id=bc97e302&scoped=true&"
import script from "./InterfaceView.vue?vue&type=script&lang=ts&"
export * from "./InterfaceView.vue?vue&type=script&lang=ts&"
import style0 from "./InterfaceView.vue?vue&type=style&index=0&id=bc97e302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc97e302",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
